require('./filter-value-input.component.scss');

export class FilterValueInputController {
  constructor($scope, $element, $http, rx, observeOnScope, CurrentModelService, ErrorHandlerService) {
    this.$scope = $scope;
    this.$element = $element;
    this.$http = $http;
    this.rx = rx;
    this.ErrorHandlerService = ErrorHandlerService;
    this.CurrentModelService = CurrentModelService;
    this.filteredSuggestions = [];
    this.suggestions = [];
    this.current = {
      label: this.label,
      value: this.value
    };
    this.subscriptions = [
      rx.Observable.merge(
        rx.Observable.merge(
          observeOnScope($scope, '$ctrl.dimension'),
          observeOnScope($scope, '$ctrl.hierarchy'),
        ).do(() => {
          this.current = {
            label: this.label,
            oldLabel: this.label,
            value: this.value,
          };
        }),
        observeOnScope($scope, '$ctrl.current.label'),
        observeOnScope($scope, '$ctrl.focused'),
      )
      .debounce(200)
      .do(() => {
        if (this.boolean) {
          const key = `${this.dimension}.${this.hierarchy}`;
          this.suggestions = [{
              [key]: 'false',
            },
            {
              [key]: 'true',
            },
          ];
          $scope.$digest();
        }
      })
      .filter(value => {
        return !this.boolean && this.focused;
      })
      .do(() => {
        this.loading = true;
        this.suggestions = [];
        // $scope.$digest();
      })
      .switchMap(() => this.getSuggestions(this.current.label))
      .do(() => {
        this.loading = false;
      })
      .subscribe(
        (suggestions) => {
          this.suggestions = suggestions;
          $scope.$digest();
        },
        (error) => {
          console.error(error);
          this.loading = false;
          $scope.$digest();
        },
      ),
    ];
    this.error = false;
  }

  $onInit() {}

  $onDestroy() {
    this.subscriptions.forEach((s) => s.dispose());
  }

  setValue(suggestion) {
    const cellFilter = this.CurrentModelService.model.getCellFilter(
      this.fullDimension,
      suggestion,
    );
    this.value = cellFilter.value;
    this.label = cellFilter.label;
    this.current = {
      label: this.label,
      value: this.value
    };
  }

  getDropdownLabel(suggestion) {
    return suggestion.dropdownLabel || (suggestion.dropdownLabel =
      this.CurrentModelService.model.getCellLabel(this.fullDimension, suggestion));
  }

  getSuggestions(lookup) {
    let url = `/analytics/values/${this.CurrentModelService.cube.name}/?drill=${this.fullDimension}&limit=100`;
    if (lookup) url = `${url}&lookup=${lookup}`;
    return this.rx.Observable.fromPromise(
        this.$http.get(url))
      .map(suggestions => suggestions.data.cells);
  }

  onFocus() {
    this.focused = true;
    this.isOpen = true;
  }

  onBlur() {
    this.focused = false;
    this.isOpen = false;
    if (this.current.value) {
      this.value = this.current.value;
      this.label = this.current.label;
      return;
    }
    if (this.filteredSuggestions.length) {
      this.setValue(this.filteredSuggestions[0]);
      return;
    }
    this.value = this.current.value ? this.current.value : this.current.label;
    this.label = this.current.label;
  }

  get fullDimension() {
    try {
      const hierarchy = this.CurrentModelService.model.getHierarchy(
        `${this.dimension}@${this.hierarchy}`).toString();
      this.prevDimension = this.dimension;
      this.prevHierarchy = this.hierarchy;
      return hierarchy;
    } catch (err) {

      this.ErrorHandlerService.filterErrorMessage.text = gettext('Неправильные параметры') + ` "dimension" : "${this.dimension}" ` +
        gettext('или') + ` "hierarchy" : "${this.hierarchy}"`;
      this.ErrorHandlerService.filterErrorMessage.source = 'query-dimention';

      console.error(this.ErrorHandlerService.filterErrorMessage.text);
      // console.error(err);
      return 'agent_eventtype@default:agent_eventtype';
    }
  }

  // filterSuggestions() {
  //   this.filteredSuggestions = this.current.label ?
  //     this.suggestions.filter(suggestion =>
  //       this.getDropdownLabel(suggestion).toLowerCase().startsWith(
  //         this.current.label.toLowerCase())) : this.suggestions;
  // }
}

export const FilterValueInputComponent = {
  bindings: {
    value: '=',
    label: '=',
    dimension: '<',
    multiple: '<',
    hierarchy: '<',
    boolean: '<',
  },
  template: require('./filter-value-input.component.html'),
  controller: FilterValueInputController,
};



// WEBPACK FOOTER //
// ./src/filter/query-builder/filter-value-input.component.js